module.exports = __webpack_public_path__ + "img/Damp 7.jpg";